import React, { Fragment } from 'react';
import Navbar from '../../components/Navbar/Navbar';
import InsuranceBanner from '../../components/InsuranceBanner/InsuranceBanner';
import PageTitle from '../../components/pagetitle/PageTitle';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Footer from '../../components/footer/Footer';
import Logo from '../../images/logo-2.svg';

const TermsPage = () => {
    return (
        <Fragment>
            <Navbar hclass={'wpo-site-header wpo-site-header-s2'} Logo={Logo} />
            <InsuranceBanner />
            <PageTitle pageTitle={'Terms of Service'} pagesub={'Terms'} />
            <div className="section-padding">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-10 offset-lg-1">
                            <div style={{
                                padding: '40px',
                                background: '#fff',
                                borderRadius: '15px',
                                boxShadow: '0 5px 20px rgba(0,0,0,0.08)'
                            }}>
                                <h2 style={{fontSize: '36px', marginBottom: '30px', color: '#2c3e50'}}>Terms of Service</h2>
                                
                                <p style={{fontSize: '16px', lineHeight: '1.8', marginBottom: '20px', color: '#666'}}>
                                    <strong>Effective Date: January 2025</strong>
                                </p>

                                <h3 style={{fontSize: '24px', marginTop: '30px', marginBottom: '15px', color: '#333'}}>Acceptance of Terms</h3>
                                <p style={{fontSize: '16px', lineHeight: '1.8', marginBottom: '20px', color: '#666'}}>
                                    By accessing and using this website, you accept and agree to be bound by the terms 
                                    and provision of this agreement.
                                </p>

                                <h3 style={{fontSize: '24px', marginTop: '30px', marginBottom: '15px', color: '#333'}}>Medical Disclaimer</h3>
                                <p style={{fontSize: '16px', lineHeight: '1.8', marginBottom: '20px', color: '#666'}}>
                                    The information provided on this website is for general informational purposes only and 
                                    should not be considered medical advice. Always consult with qualified healthcare professionals 
                                    for personalized medical guidance.
                                </p>

                                <h3 style={{fontSize: '24px', marginTop: '30px', marginBottom: '15px', color: '#333'}}>Appointment Terms</h3>
                                <p style={{fontSize: '16px', lineHeight: '1.8', marginBottom: '20px', color: '#666'}}>
                                    Consultations are subject to availability. We reserve the right to reschedule appointments 
                                    as necessary. Patients must provide 24-hour notice for cancellations.
                                </p>

                                <h3 style={{fontSize: '24px', marginTop: '30px', marginBottom: '15px', color: '#333'}}>Limitation of Liability</h3>
                                <p style={{fontSize: '16px', lineHeight: '1.8', marginBottom: '20px', color: '#666'}}>
                                    Treatment outcomes vary by individual. We make no guarantees regarding specific results. 
                                    All treatments are provided based on professional medical evaluation and patient suitability.
                                </p>

                                <h3 style={{fontSize: '24px', marginTop: '30px', marginBottom: '15px', color: '#333'}}>Contact Us</h3>
                                <p style={{fontSize: '16px', lineHeight: '1.8', marginBottom: '20px', color: '#666'}}>
                                    For questions regarding these terms, please contact:<br/>
                                    Email: info@ampedtherapeutics.com
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer hclass={'wpo-site-footer_s2'} />
            <Scrollbar />
        </Fragment>
    );
};

export default TermsPage;